<template>
  <div class="row flex-center table-input">
    <div class="leftname" v-if="showLeftName">
      {{ leftname }}
    </div>
    <div class="flex-1 input-wrapper">
      <el-autocomplete
        class="fw100"
        v-bind="$attrs"
        v-model.trim="inputVal"
        :fetch-suggestions="querySearch"
        :popper-class="'P-customPopperClass'"
        :popper-append-to-body="false"
        :size="size"
        :title="inputVal"

      />
    </div>
  </div>
</template>

<script>
// 选项式 API，保持与旧版一致的使用方式
export default {
  name: "TableInputAutoComplete",
  props: {
    self: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    showLeftName: {
      type: Boolean,
      default: true,
    },
    leftname: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "",
    },
    modelval: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      inputVal: "",
    };
  },
  mounted() {
    this.formatValue();
  },
  watch: {
  },
  methods: {
    // 根据传入的 self / modelval 初始化显示值
    formatValue() {
      this.inputVal = ""
    },
    emitFocus(event) {
      this.$emit("focus", event);
    },
    emitBlur(event) {
      this.$emit("blur", event);
    },
    emitEnter() {
      this.$emit("keyUpSearch");
    },
    querySearch(queryString, cb) {
      this.$emit("QuerySubmit", {
        value: queryString,
        cb,
      });
    },
    normalizeValue(val) {
      if (val && typeof val === "object" && "target" in val) {
        return val.target?.value ?? "";
      }
      return val ?? "";
    },
    handleInput(val) {
      const nextVal = this.normalizeValue(val);
      this.inputVal = nextVal;
      // 同步到外部数据结构
      if (!this.modelval) {
        this.$emit("update:self", nextVal);
      } else if (this.self) {
        this.self[this.modelval] = nextVal;
      }
      // 兼容 v-model / input
      this.$emit("input", nextVal);
      this.$emit("update:modelValue", nextVal);
    },
    handleSelect(payload) {
      this.$emit("select", payload);
    },
  },
};
</script>

<style scoped lang="scss">
.table-input {
  font-size: 13px;
  background-color: #fff;
  padding: 0 0 0 12px;
  border-radius: 4px;
  border: 1px solid #e6e6e6;
  position: relative;

  .leftname {
    text-align: right;
    line-height: 30px;
    color: #666;
    margin-right: 8px;
  }

  .input-wrapper {
    position: relative;
  }
}

:deep(.el-input__wrapper) {
  box-shadow: none !important;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border: none;
  line-height: 32px;
  height: 30px;
  color: #333;
}

</style>
